"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var get_selector_from_element_1 = require("../get-selector-from-element");
function getSelectorElementFromElement(element, attribute, fallbackHref) {
    if (attribute === void 0) { attribute = 'data-target'; }
    if (fallbackHref === void 0) { fallbackHref = true; }
    var selector = get_selector_from_element_1.default(element, attribute, fallbackHref);
    if (selector && selector.indexOf('#') === 0) {
        return document.getElementById(selector.substr(1, selector.length - 1));
    }
    return null;
}
exports.default = getSelectorElementFromElement;
